import styled from '@emotion/styled'
import { IconCross } from '../../../../navigation/TNFlyoutNav/assets/IconCross'
import {
    getComponentTheme,
    breakpointSwitch,
    calcRem,
} from '../../../../__styling'
import { keyframes } from '@emotion/css'
interface StyledContainerProps {
    isHidden: boolean
}

export const StyledContainer = styled.div<StyledContainerProps>(
    ({ theme, isHidden }) => {
        const stickyAccountBannerTheme = getComponentTheme(
            theme,
            'stickyAccountBanner',
        )

        return [
            {
                background: stickyAccountBannerTheme.background,
                paddingLeft: stickyAccountBannerTheme.paddingHorizontal,
                paddingRight: stickyAccountBannerTheme.paddingHorizontal,
                paddingTop: stickyAccountBannerTheme.paddingVertical,
                paddingBottom: stickyAccountBannerTheme.paddingVertical,
                width: stickyAccountBannerTheme.width,
                display: stickyAccountBannerTheme.display,
                alignItems: stickyAccountBannerTheme.alignItems,
                gap: stickyAccountBannerTheme.gap,
                position: stickyAccountBannerTheme.position,
                zIndex: stickyAccountBannerTheme.zIndex,
                top: `var(--stickyHeaderHeight)`,

                transition: 'top 0.25s',

                animationTimingFunction: 'ease',
                animationFillMode: 'forwards',

                '&': [
                    // stick to the top of the page directly, no animation needed
                    !isHidden && {
                        animationDuration: '250ms',
                        animationName: keyframes({
                            '0%': { opacity: 0 },
                            '100%': {
                                opacity: 1,
                            },
                        }),
                    },
                ],
            },
        ]
    },
)

export const StyledRowContainer = styled.div(({ theme }) => {
    const { rowContainer } = getComponentTheme(theme, 'stickyAccountBanner')
    return [
        {
            margin: rowContainer.margin,
            position: rowContainer.position,
            maxWidth: rowContainer.maxWidth,
            display: rowContainer.display,
            alignItems: rowContainer.alignItems,
            gap: rowContainer.gap,
            background: rowContainer.background,
            borderTop: rowContainer.borderTop,
            paddingLeft: rowContainer.paddingHorizontal,
            paddingRight: rowContainer.paddingHorizontal,
            paddingTop: rowContainer.paddingVertical,
            paddingBottom: rowContainer.paddingVertical,
        },
    ]
})

export const StyledInnerRowContainer = styled.div<{ hasGap?: boolean }>(
    ({ theme, hasGap }) => {
        const { innerRowContainer } = getComponentTheme(
            theme,
            'stickyAccountBanner',
        )

        return [
            {
                position: innerRowContainer.position,
                display: innerRowContainer.display,
                alignItems: innerRowContainer.alignItems,
            },
            breakpointSwitch(
                innerRowContainer.flexDirection,
                (flexDirection) => ({
                    flexDirection,
                }),
            ),
            hasGap &&
                breakpointSwitch(innerRowContainer.gap, (gap) => ({
                    gap,
                })),
        ]
    },
)

export const StyledInnerLinkRowContainer = styled.div(({ theme }) => {
    const { innerRowContainer, textLink } = getComponentTheme(
        theme,
        'stickyAccountBanner',
    )
    return {
        display: innerRowContainer.display,
        gap: '1rem',
        flexDirection: 'row',
        flexWrap: 'wrap',
    }
})

export const StyledCloseButton = styled.button(({ theme }) => {
    const { closeButton } = getComponentTheme(theme, 'stickyAccountBanner')
    return [
        {
            flexShrink: closeButton.flexShrink,
            display: closeButton.display,
            background: closeButton.background,
            border: closeButton.border,
            margin: closeButton.margin,
            padding: closeButton.padding,
            textUnderlinePosition: closeButton.textUnderlinePosition,

            '&:focus-within': {
                svg: {
                    path: {
                        fill: closeButton.iconFocusFill,
                    },
                },
            },
        },
    ]
})
export const StyledIconCross = styled(IconCross)(({ theme }) => {
    const { icon } = getComponentTheme(theme, 'stickyAccountBanner')

    return [
        {
            height: icon.height,
            width: icon.width,

            path: {
                fill: icon.fill,
            },
            '&:hover': {
                cursor: 'pointer',
            },
            [`&:is(:hover, :focus)`]: {
                path: {
                    fill: icon.hover.fill,
                },
            },
        },
    ]
})

export const StyledTextContainer = styled.p(({ theme }) => {
    const { textContainer } = getComponentTheme(theme, 'stickyAccountBanner')

    return [
        {
            fontSize: textContainer.fontSize,
            lineHeight: textContainer.lineHeight,
            fontStyle: textContainer.fontStyle,
            fontWeight: textContainer.fontWeight,
            color: textContainer.color,
            fontFamily: textContainer.fontFamily,
            margin: 0,
        },
    ]
})

export const StyledMessagesContainer = styled.div(({ theme }) => {
    const { messagesContainer } = getComponentTheme(
        theme,
        'stickyAccountBanner',
    )

    return [
        {
            display: messagesContainer.display,
        },
        breakpointSwitch(messagesContainer.flexDirection, (flexDirection) => ({
            flexDirection,
        })),
        breakpointSwitch(messagesContainer.gap, (gap) => ({
            gap,
        })),
    ]
})

export const StyledTextLink = styled.button(({ theme }) => {
    const { textLink } = getComponentTheme(theme, 'stickyAccountBanner')

    return [
        {
            textDecoration: textLink.textDecoration,
            color: textLink.color,
            fontSize: textLink.fontSize,
            lineHeight: textLink.lineHeight,
            fontStyle: textLink.fontStyle,
            fontWeight: textLink.fontWeight,
            fontFamily: textLink.fontFamily,
            padding: textLink.padding,
            background: 'none',
            border: 'none',
            position: 'relative',

            '&:hover': {
                cursor: 'pointer',
            },
            [`&:is(:hover, :focus)`]: {
                color: textLink.hover.color,
            },
            '&:not(:first-of-type)::before': {
                content: '""',
                width: '1px',
                height: '80%',
                position: 'absolute',
                backgroundColor: textLink.color,
                left: '-0.5rem',
                margin: calcRem(3, 0),
            },
        },
    ]
})
